module.exports = __webpack_public_path__ + "img/logo.dd9176f1.svg";